import Vue from 'vue'
import router from "./router.js"
import { BootstrapVue, BootstrapVueIcons, IconsPlugin, BIcon  } from 'bootstrap-vue'
import { VclFacebook } from 'vue-content-loading';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import './assets/css/docs.min.css'
import './assets/css/button.css'
import './assets/scss/app.scss'
import 'vue-select/dist/vue-select.css';
import 'pdfvuer/dist/pdfvuer.css';
import 'vue2-timepicker/dist/VueTimepicker.css';
import axios from 'axios'
import App from './App.vue'
import AppNoDataImage from './components/AppNoDataImage.vue'
import AppInboxLoading from './components/AppInboxLoading.vue'
import AppIconEdit from './components/AppIconEdit.vue'
import AppLongText from './components/AppLongText.vue'
import AppCurrencyLabel from './components/AppCurrencyLabel.vue'
import AppIconApprove from './components/AppIconApprove.vue'
import AppIconReject from './components/AppIconReject.vue'
import AppIconRevise from './components/AppIconRevise.vue'

import store from './store'
import ClickConfirm from './components/ClickConfirm.vue'
import titleMixin from './mixins/titleMixin'
import publicPathMixin from './mixins/publicPathMixin'
import PortalVue from 'portal-vue'
import "wicg-inert"
import api from "./services/api";
import LiquorTree from 'liquor-tree'
import { setHeaderToken } from './utils/auth'
import VueApexCharts from 'vue-apexcharts'
import VueTimepicker from 'vue2-timepicker';

if(process.env.VUE_APP_API_URL.startsWith('http')) {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;
} else {
  let baseUrl = window.location.origin;
  if(!process.env.VUE_APP_API_URL.startsWith('/')) baseUrl += '/';
  axios.defaults.baseURL = baseUrl + process.env.VUE_APP_API_URL;
}
const token = localStorage.getItem('access_token');

if (token) { 
  setHeaderToken(token);
} 


// global registration
Vue.use(LiquorTree)
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)
Vue.use(VueScrollTo, {
      container: "body",
      duration: 500,
      easing: "ease",
      offset: 0,
      force: true,
      cancelable: true,
      onStart: false,
      onDone: false,
      onCancel: false,
      x: false,
      y: true
  })

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

Vue.mixin(titleMixin)
Vue.mixin(publicPathMixin)
Vue.use(PortalVue)
Vue.use(BootstrapVue, axios)
Vue.use(BootstrapVueIcons)
Vue.use(IconsPlugin)
Vue.use(require('vue-moment'));

Vue.component('vclFacebook', VclFacebook)
Vue.component('BIcon', BIcon)
Vue.component('app-no-data-image', AppNoDataImage);
Vue.component('app-inbox-loading', AppInboxLoading);
Vue.component('app-icon-edit', AppIconEdit);
Vue.component('app-long-text', AppLongText);
Vue.component('app-currency-label', AppCurrencyLabel);
Vue.component('app-icon-approve', AppIconApprove);
Vue.component('app-icon-reject', AppIconReject);
Vue.component('app-icon-revise', AppIconRevise);
Vue.component('vue-timepicker', VueTimepicker);
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

const clickConfirmPlugin = (Vue, params) => {
  let name = 'click-confirm';
  if (typeof params === 'string') name = params;

  Vue.component(name, ClickConfirm);
};

ClickConfirm.install = clickConfirmPlugin;
Vue.component('clickConfirm', ClickConfirm);

Vue.config.productionTip = false
Vue.prototype.$http = api; 
api.defaults.timeout = 1000000;

setInterval(() => {
  const oldToken = localStorage.getItem('access_token');
  //console.log("oldToken", oldToken);
  if(oldToken == null || oldToken == undefined) {
    api.post(process.env.VUE_APP_API_URL + `Auth/refreshtoken`).then(result => {
      if(result != null || result != undefined) {
        if(result.data) {
          let token = result.data.token;
          setHeaderToken(token);
        }
      }
    });
  }
}, 600000);

api.interceptors.request.use(
  config => {
    const token = window.localStorage.getItem("access_token");
    if (token) {
      config.headers.common["Authorization"] = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

Vue.filter('countFilter', function (value, filter) {
  let filterCount = 0;
  for (var propName in filter) {
    if (Object.prototype.hasOwnProperty.call(filter, propName)) {
      if (filter[propName] != null && filter[propName] != undefined && filter[propName] != '' && typeof filter[propName] != 'object') {
        filterCount++;
      }
    }
  }
  return filterCount > 0 ? value + ' (' + filterCount + ')' : value;
});

Vue.filter('thousandSeparator', function (value) {
  if (!value) return '0';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

store.dispatch('get_user').then(()=>{
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}).catch((error) => {
  console.log(error);
});

